<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.page_heading" [ttModel]="edit.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="prod_name_choice" [ttModel]="edit.prod_name_choice" [ttButtons]="productNameChoiceButtons" ttReadonly></tt-input>
        <tt-input *ngIf="edit.prod_id !== edit.choice_belong_to_prod_id" ttLabel="choice_belong_to_prod_name" [ttModel]="edit.choice_belong_to_prod_name" ttReadonly></tt-input>
        <tt-input ttLabel="stdchoice_prod_id" [(ttModel)]="edit.stdchoice_prod_id"></tt-input>
        <tt-checkbox ttLabel="lock_possibilities" [(ttModel)]="edit.lock_possibilities"></tt-checkbox>
        <tt-button-save ttText="choice_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button-goto [ttText]="'choicepossibilities'" [ttBadge]="edit.nbr_of_choicepossibilities" [ttGoto]="'choicepossibilitylist'" [ttGotoParms]="{ choice_keyno: edit.choice_keyno }"></tt-button-goto>
    </tt-card>
</tt-page>
